


































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import _ from "lodash";
import RequestRepository from "@/repositories/request/RequestRepository";
import {User} from "front-component/modules/User";
import Tag from "@/components/miscellaneous/Tag.vue";
import {Select as elSelect} from "element-ui";
import {requestStatus, roleClient} from "@/Constants";
import EventBus from "front-component/EventBus";

const components = {
    Tag,
};

@Component({components})
export default class Status extends Vue {
    private currentStatus: string = requestStatus.draft;
    private loading: boolean = true;
    private isShowedSelect: boolean = false;

    @Prop(String) private requestUuid!: string;
    @Prop(Boolean) private disabled!: boolean;
    @Prop(Boolean) private disabledEdition!: boolean;

    @Getter("getCurrentUser") public currentUser!: User;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getOwnerWorkflow") public getOwnerWorkflow!: (isClient: boolean) => any[];

    @Watch("requestUuid")
    private changeRequest() {
        this.retrieveRequestStatus();
    }

    private created() {
        EventBus.$on("request-status-updated", (newStatus: string, requestUuid: string) => {
            if (requestUuid === this.requestUuid) {
                this.currentStatus = newStatus;
            }
        });
    }

    private mounted() {
        this.retrieveRequestStatus();
        EventBus.$on("request-assigned-updated", this.updateStatusAfterAssigned);
    }

    private beforeDestroy(): void {
        EventBus.$off("request-assigned-updated", this.updateStatusAfterAssigned);
    }

    private get requestStatusList(): string[] {
        const requestStatusClientSM = this.getOwnerWorkflow(true);
        const requestStatusNonClientSM = this.getOwnerWorkflow(false);

        if (0 <= _.indexOf(this.currentUser.roles, roleClient)) {
            return _.get(requestStatusClientSM, this.currentStatus, []);
        }

        return _.get(requestStatusNonClientSM, this.currentStatus, []);
    }

    private retrieveRequestStatus(after: (() => void) | null = null) {
        if (!this.requestUuid) {
            this.currentStatus = requestStatus.draft;
            this.loading = false;
            return;
        }

        this.loading = true;
        const statusParams = {
            fields: [
                "uuid",
                "status",
            ],
            filters: {
                uuid: this.requestUuid,
            }
        };

        RequestRepository.get(statusParams).then((requests) => {
            this.currentStatus = _.get(requests, "0.status", requestStatus.draft);
            if (!_.isNull(after)) {
                after();
            } else {
                this.loading = false;
            }
        });
    }

    private toggleSelect(showed: boolean) {
        this.isShowedSelect = showed;

        if (this.isShowedSelect) {
            this.$nextTick(() => {
                const selectComponent = _.get(this.$refs, "statusSelect", null);
                if (selectComponent) {
                    (selectComponent as elSelect).focus();
                }
            });
        }
    }

    private updateStatusAfterAssigned(uuid: string): void {
        if (uuid !== this.requestUuid ||
            requestStatus.todo !== this.currentStatus ||
            0 <= _.indexOf(this.currentUser.roles, roleClient)
        ) {
            return;
        }
        this.$confirm(_.invoke(this.$options.filters, "trans", "updateStatusToOngoing"),
            {
                confirmButtonText: _.invoke(this.$options.filters, "trans", "yes"),
                cancelButtonText: _.invoke(this.$options.filters, "trans", "no"),
            })
            .then(() => this.saveStatus(requestStatus.onGoing))
            .catch(() => 0)
        ;
    }

    private saveStatus(newStatus: string) {
        this.loading = true;
        const oldLocalStatus = this.currentStatus;
        this.retrieveRequestStatus(() => {
            if (this.currentStatus === newStatus) {
                // Nothing to do
                this.loading = false;

                return;
            }

            if (oldLocalStatus !== this.currentStatus) {
                this.$message({
                    type: "error",
                    message: _.invoke(this.$options.filters, "trans", "someoneAlreadyChangeTheStatus"),
                });
                this.loading = false;

                return;
            }

            const newStatusSaveData = {
                uuid: this.requestUuid,
                status: newStatus,
            };

            const newStatusReturnParams = {
                fields: [
                    "uuid",
                    "status",
                ]
            };

            RequestRepository.save(newStatusSaveData, newStatusReturnParams).then((request) => {
                this.currentStatus = _.get(request, "status", "");
                this.loading = false;
                this.$emit("change", this.currentStatus);
                EventBus.$emit("request-status-updated", this.currentStatus, this.requestUuid);
            });
        });
    }
}
